class SoarAnnouncementBar extends HTMLElement {
  connectedCallback() {
    this.messages = Array.from(this.querySelectorAll('.soar-announcement-bar__message'));
    if (this.messages.length <= 1) return;

    this.current = 0;
    this.autoplay = this.dataset.autoplay === 'true';
    this.cycleMs = (parseInt(this.dataset.cycleSpeed, 10) || 5) * 1000;
    this.paused = false;

    this.bindControls();
    this.bindHover();
    if (this.autoplay) this.start();
  }

  disconnectedCallback() {
    this.stop();
  }

  bindControls() {
    this.querySelectorAll('[data-soar-announcement-nav]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const dir = btn.dataset.soarAnnouncementNav === 'next' ? 1 : -1;
        this.go(this.current + dir);
        this.restart();
      });
    });
  }

  bindHover() {
    this.addEventListener('mouseenter', () => { this.paused = true; });
    this.addEventListener('mouseleave', () => { this.paused = false; });
    this.addEventListener('focusin', () => { this.paused = true; });
    this.addEventListener('focusout', () => { this.paused = false; });
  }

  go(index) {
    const len = this.messages.length;
    const next = ((index % len) + len) % len;
    this.messages[this.current].classList.remove('is-active');
    this.messages[next].classList.add('is-active');
    this.current = next;
  }

  start() {
    this.timer = window.setInterval(() => {
      if (!this.paused) this.go(this.current + 1);
    }, this.cycleMs);
  }

  stop() {
    if (this.timer) window.clearInterval(this.timer);
    this.timer = null;
  }

  restart() {
    this.stop();
    if (this.autoplay) this.start();
  }
}

if (!customElements.get('soar-announcement-bar')) {
  customElements.define('soar-announcement-bar', SoarAnnouncementBar);
}
